import { NumberFormatType } from '../enum/formatPricePercentEnum';
import formatterNumber from './formatterNumber';

export default function formatterPercent(
  value: number,
  options?: Intl.NumberFormatOptions,
) {
  return formatterNumber(value, {
    style: NumberFormatType.percent,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    ...options,
  });
}
